// extracted by mini-css-extract-plugin
export default {"container":"ValueOfVehicle_container__-fDEg","paragraf":"ValueOfVehicle_paragraf__doYBA","input":"ValueOfVehicle_input__2E9w+"};